import { render, staticRenderFns } from "./NameValueBlock.vue?vue&type=template&id=b80f558a&scoped=true&"
import script from "./NameValueBlock.vue?vue&type=script&lang=js&"
export * from "./NameValueBlock.vue?vue&type=script&lang=js&"
import style0 from "./NameValueBlock.vue?vue&type=style&index=0&id=b80f558a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f558a",
  null
  
)

export default component.exports